<template>
  <div class="tag-item">
    <div
      class="tag-cell"
      @click="onClickTagBox"
    >
      <div
        v-if="result.length"
        class="value"
      >
        <span
          v-for="(item, i) in result"
          :key="i"
          class="tag border-bottom-1px"
        > {{ $getStrleng(item) > 15 ? $substr(item, 15) : item }}
          <i
            class="iconfont iconicon-test28 del-btn"
            @click="onDelete(item, i)"
          />
        </span>
      </div>
      <div class="input-add">
        <input
          ref="tagInput"
          v-model="newValue"
          type="text"
          class="input"
          :placeholder="tagInputPlace"
          @blur="add"
          @keyup="handleKeyup($event)"
        >
        <!-- <i
          class="iconfont iconicon-test36 add-btn"
          @click="add"
        /> -->
      </div>
    </div>
    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="data.fieldvalue"
      :data="data"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
  </div>
</template>
<script>

export default {
  props: {
    'data': {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      result: [],
      newValue: ''
    }
  },
  computed: {
    tagInputPlace () {
      return this.$t('message["776"]')
    }
  },
  created () {
    this.result = this.data.fieldvalue
  },
  methods: {
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    handleKeyup (ev) {
      if (ev.keyCode === 32 || ev.keyCode === 13) {
        this.add()
      }
    },
    add () {
      if (!this.newValue.trim()) return
      if (this.result.includes(this.newValue)) {
        this.$createToast({
          type: 'warn',
          txt: this.$t('message["66"]'),
          time: 1000
        }).show()
        this.newValue = ''
        return
      }
      this.result.push(this.newValue.trim())
      this.newValue = ''

      this.data.fieldvalue = this.result
      this.$emit('change', this.data.fieldvalue)
    },
    onDelete (item, i) {
      this.result.splice(i, 1)
      this.data.fieldvalue = this.result
      this.$emit('change', this.data.fieldvalue)
    },
    onClickTagBox () {
      this.$refs.tagInput.focus()
    }
  }
}
</script>
<style lang="scss" scoped>
.tag-cell {
  .value {
    display: inline-block;
    width: 100%;
    line-height: 34px;
    padding-top: 10px;
    border-radius: 3px;
  }
  .tag {
    position: relative;
    display: inline-block;
    height: 24px;
    line-height: 24px;
    margin: 0 5px 5px 0;
    padding: 0 6px;
    font-style: normal;
    font-size: 12px;
    white-space: nowrap;
    text-align: center;
    border-radius: 4px;
    border: solid 1px $gray4;
    .iconfont.del-btn {
      /* position: absolute;
      top: -8px;
      right: -6px; */
      font-size: 10px;
      color: #333;
    }
  }
  .input-add {
    display: flex;
    margin: 10px 0;
    .cube-input-field {
      padding: 0;
    }
  }
  .input {
    width: 180px;
    height: 24px;
    line-height: 24px;
    margin-right: 10px;
    font-size: 14px;
    border: none;
    outline: none;
    &::-webkit-input-placeholder {
      color: #d6d6d6;
    }
  }
  .iconfont.add-btn {
    height: 24px;
    line-height: 24px;
    color: #5077aa;
  }
}
</style>
